import { setCookie } from './cookieHelpers'
import { stripLocaleFromPath, prependLocale, getLocaleFromPath, hasHreflangAlternates, localizedAlternateUrl } from './localeHelpers'
import { postFetchWrapper } from './fetchHelpers'

export function markPreferenceSet () {
  setCookie('locale_preference_set', 'true', 365)
}

export async function applyPreferences (language, currency) {
  setCookie('user_currency', currency, 365)
  markPreferenceSet()
  // Await persistence so the next request reads the new preference; navigate anyway if it fails.
  try {
    await persistPreferencesToUser(language, currency)
  } catch {}

  navigateOrReload(destinationForLanguage(language))
}

export function destinationForLanguage (language) {
  const { pathname, search } = window.location
  const currentLanguage = document.body.dataset.locale || getLocaleFromPath(pathname) || 'en'
  const swappedPrefixUrl = prependLocale(stripLocaleFromPath(pathname) || '/', language) + search

  // Currency-only change: reload the current page unchanged.
  if (language === currentLanguage) return swappedPrefixUrl

  const localeHome = language === 'en' ? '/' : `/${language}`
  const destination = hasHreflangAlternates()
    ? localizedAlternateUrl(language) || localeHome
    : swappedPrefixUrl

  // sortBy/p don't carry across locales: sort indexes are named per-locale and other locales may have fewer pages.
  return dropCrossLocaleParams(destination)
}

function dropCrossLocaleParams (url) {
  const parsed = new URL(url, window.location.origin)
  parsed.searchParams.delete('sortBy')
  parsed.searchParams.delete('p')

  return /^https?:\/\//i.test(url) ? parsed.href : parsed.pathname + parsed.search + parsed.hash
}

// Same-URL assignment is a no-op in browsers, so reload to pick up the new preference.
function navigateOrReload (href) {
  const { pathname, search } = window.location
  if (href === pathname + search) {
    window.location.reload()
  } else {
    window.location.href = href
  }
}

function persistPreferencesToUser (locale, currency) {
  return postFetchWrapper('/api/v1/locale_preferences', { locale, currency })
}
